export const endpoints = {
  messages: '/messages',

  threads: '/message-threads',
  thread: '/message-threads/{id}',
  threadMessages: '/message-threads/{threadId}/messages',
  threadMessage: '/message-threads/{threadId}/messages/{id}',
} as const;

export const messagingSections = {
  drafts: 'drafts',
  conversations: 'conversations',
} as const;

export const messageIdQueryParamKey = {
  [messagingSections.drafts]: 'messageId',
  [messagingSections.conversations]: 'threadId',
} as const;
